import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

const ProductDetails = () => {
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState('Features');
  const [selectedColor, setSelectedColor] = useState('black');
  const { addToCart } = useCart();

  const similarProducts = [
    {
      id: 1,
      title: 'Classic Aviator',
      brand: 'RAYBAN',
      price: '129.99',
      category: 'Sunglasses',
      desc: 'Premium quality sunglasses designed for maximum comfort and style.',
      image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=600&auto=format'
    },
    {
      id: 2,
      title: 'Metro Square',
      brand: 'OAKLEY',
      price: '89.99',
      category: 'Eyeglasses',
      desc: 'Sleek and modern frames designed for everyday wear and durability.',
      image: 'https://images.unsplash.com/photo-1591076482161-42ce6da69f67?w=600&auto=format'
    },
    {
      id: 3,
      title: 'Round Vintage',
      brand: 'SILHOUETTE',
      price: '99.99',
      category: 'Eyeglasses',
      desc: 'Classic round frames that bring a touch of vintage elegance to any look.',
      image: 'https://images.unsplash.com/photo-1577803645773-f96470509666?w=600&auto=format'
    }
  ];

  const mainImage = "https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=800&auto=format";
  const thumbs = [mainImage, mainImage, mainImage, mainImage]; // Using same image for demo

  const mainProduct = {
    id: 100,
    title: 'Executive Pro',
    brand: 'OAKLEY',
    price: '189.00',
    category: 'Eyeglasses',
    desc: 'The Executive Pro combines professional aesthetics with high-performance materials.',
    image: mainImage
  };

  return (
    <div className="min-h-screen bg-white pb-20 pt-[18px]">
      <div className="page-container">
        
        {/* Breadcrumb */}
        <div className="flex items-center text-[13px] mb-8">
          <Link to="/" className="text-gray-500 hover:text-[#2A3182]">Home</Link>
          <span className="mx-2 text-gray-300">/</span>
          <Link to="/shop" className="text-gray-500 hover:text-[#2A3182]">Shop</Link>
          <span className="mx-2 text-gray-300">/</span>
          <span className="text-gray-900 font-bold">Executive Pro</span>
        </div>

        {/* Product Section */}
        <div className="mb-16 flex flex-col gap-10 lg:flex-row lg:gap-12">
          
          {/* Image Gallery */}
          <div className="lg:w-1/2">
            <div className="mb-4 flex aspect-[4/3] items-center justify-center overflow-hidden rounded-[24px] bg-[#f8f9fa] p-5 sm:rounded-[30px] sm:p-8">
              <img src={mainImage} alt="Executive Pro" className="h-full w-full object-contain transition-transform duration-500 hover:scale-105" />
            </div>
            <div className="grid grid-cols-4 gap-3 sm:gap-4">
              {thumbs.map((thumb, idx) => (
                <div key={idx} className={`aspect-square cursor-pointer rounded-[15px] border-2 bg-[#f8f9fa] p-2 transition-all ${idx === 0 ? 'border-[#ddd]' : 'border-transparent hover:border-[#ddd]'}`}>
                  <img src={thumb} alt={`Thumbnail ${idx+1}`} className="h-full w-full rounded-[10px] object-cover" />
                </div>
              ))}
            </div>
          </div>

          {/* Product Info */}
          <div className="lg:w-1/2 flex flex-col justify-center">
            <p className="text-[#ef4444] text-[13px] font-bold tracking-[0.2em] uppercase mb-2">OAKLEY</p>
            <h1 className="mb-3 text-[34px] font-black leading-tight text-gray-900 sm:text-[42px]">Executive Pro</h1>
            
            <div className="flex items-center gap-3 mb-6">
              <div className="flex text-[#FBBF24]">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                  </svg>
                ))}
              </div>
              <span className="text-[13px] text-gray-500 font-medium">(324 Customer Reviews)</span>
            </div>

            <div className="mb-6">
              <span className="text-[32px] font-black text-[#2A3182]">KSH. 189.00</span>
            </div>

            <p className="text-[15px] text-gray-600 leading-relaxed mb-8">
              The Executive Pro combines professional aesthetics with high-performance materials. Engineered for all-day comfort, these frames feature a lightweight titanium build and adjustable nose pads for a custom fit.
            </p>

            <div className="mb-8">
              <p className="text-[14px] font-bold text-gray-900 mb-3">Select Color</p>
              <div className="flex gap-3">
                <button 
                  onClick={() => setSelectedColor('black')}
                  className={`w-8 h-8 rounded-full bg-[#1a1a1a] ${selectedColor === 'black' ? 'ring-2 ring-offset-2 ring-black' : ''}`}
                ></button>
                <button 
                  onClick={() => setSelectedColor('blue')}
                  className={`w-8 h-8 rounded-full bg-[#2A3182] ${selectedColor === 'blue' ? 'ring-2 ring-offset-2 ring-[#2A3182]' : ''}`}
                ></button>
                <button 
                  onClick={() => setSelectedColor('grey')}
                  className={`w-8 h-8 rounded-full bg-gray-500 ${selectedColor === 'grey' ? 'ring-2 ring-offset-2 ring-gray-500' : ''}`}
                ></button>
              </div>
            </div>

            <div className="mb-10 flex flex-col gap-4 sm:flex-row">
              <div className="flex w-full items-center justify-between rounded-full border border-[#ddd] px-5 py-3 sm:w-32">
                <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="text-gray-500 hover:text-black font-bold text-lg">-</button>
                <span className="font-bold text-gray-900">{quantity}</span>
                <button onClick={() => setQuantity(quantity + 1)} className="text-gray-500 hover:text-black font-bold text-lg">+</button>
              </div>
              <button 
                onClick={() => addToCart({ ...mainProduct, quantity })}
                className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#2A3182] py-3 font-bold text-white shadow-lg transition-all hover:bg-[#1e2361] hover:shadow-xl"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 0a2 2 0 100 4 2 2 0 000-4z"/>
                </svg>
                Add to Cart
              </button>
            </div>

            {/* Info Badges */}
            <div className="flex flex-wrap gap-8 py-6 border-t border-[#ddd]">
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-[#2A3182]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-[13px] font-medium text-gray-600">2 Year Warranty</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-[#2A3182]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
                </svg>
                <span className="text-[13px] font-medium text-gray-600">Free Shipping</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-[#2A3182]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12a9 9 0 109-9 9.75 9.75 0 00-6.74 2.74L3 8m0 0V3m0 5h5" />
                </svg>
                <span className="text-[13px] font-medium text-gray-600">30 Day Returns</span>
              </div>
            </div>
            
          </div>
        </div>

        {/* Tabs Section */}
        <div className="mb-20">
          <div className="mb-8 flex flex-wrap gap-6 border-b border-[#ddd]">
            {['Features', 'Specifications', 'Shipping'].map(tab => (
              <button 
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`pb-4 text-[15px] font-bold transition-all relative ${
                  activeTab === tab 
                    ? 'text-[#2A3182]' 
                    : 'text-gray-400 hover:text-gray-600'
                }`}
              >
                {tab}
                {activeTab === tab && (
                  <div className="absolute bottom-[-1px] left-0 w-full h-[2px] bg-[#2A3182]"></div>
                )}
              </button>
            ))}
          </div>
          
          {activeTab === 'Features' && (
            <div className="flex flex-col gap-10 md:flex-row md:gap-12">
              <div className="md:w-1/2 pt-2">
                <ul className="space-y-4">
                  <li className="flex items-center text-[15px] text-gray-600 font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#ef4444] mr-4 flex-shrink-0"></span>
                    Titanium construction
                  </li>
                  <li className="flex items-center text-[15px] text-gray-600 font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#ef4444] mr-4 flex-shrink-0"></span>
                    Anti-reflective coating
                  </li>
                  <li className="flex items-center text-[15px] text-gray-600 font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#ef4444] mr-4 flex-shrink-0"></span>
                    Blue light protection
                  </li>
                  <li className="flex items-center text-[15px] text-gray-600 font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#ef4444] mr-4 flex-shrink-0"></span>
                    Lightweight design
                  </li>
                </ul>
              </div>
              <div className="md:w-1/2">
                <div className="max-w-md rounded-[20px] bg-[#f8f9fa] p-6 sm:p-8">
                  <h4 className="text-[16px] font-black text-gray-900 mb-3">Premium Packaging Included</h4>
                  <p className="text-[14px] text-gray-500 leading-relaxed font-medium">
                    Every pair of glasses comes with our signature hard case, a microfiber cleaning cloth, and a certificate of authenticity.
                  </p>
                </div>
              </div>
            </div>
          )}
          {activeTab === 'Specifications' && (
             <div className="text-gray-600 text-[15px] font-medium pt-2">
               <p>Specifications content goes here...</p>
             </div>
          )}
          {activeTab === 'Shipping' && (
             <div className="text-gray-600 text-[15px] font-medium pt-2">
               <p>Shipping information goes here...</p>
             </div>
          )}
        </div>

        {/* Similar Products */}
        <div>
          <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="text-[#ef4444] text-[12px] font-bold tracking-[0.2em] uppercase mb-2">RECOMMENDATION</p>
              <h2 className="text-[32px] font-black text-gray-900">Similar Products</h2>
            </div>
            <Link to="/shop" className="text-[#2A3182] text-[14px] font-bold hover:underline flex items-center gap-1 mb-2">
              View All 
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {similarProducts.map((product) => (
              <div key={product.id} className="group flex flex-col rounded-[25px] border border-[#ddd] bg-white p-2.5 transition-all duration-500 hover:shadow-xl">
                <Link to="/product">
                  <div className="relative aspect-square rounded-[20px] overflow-hidden bg-[#f8f9fa]">
                    <div className="absolute top-3 right-3 z-10">
                      <div className="bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full shadow-sm border border-[#ddd]">
                        <span className="text-[9px] font-black text-[#2A3182] uppercase tracking-tighter">
                          {product.category}
                        </span>
                      </div>
                    </div>
                    <img 
                      src={product.image} 
                      alt={product.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                  </div>
                </Link>
                <div className="flex flex-1 flex-col p-4 pt-4">
                  <div className="mb-1 flex items-start justify-between gap-3">
                    <Link to="/product">
                      <h3 className="text-[16px] font-bold text-gray-900 group-hover:text-[#2A3182] transition-colors leading-tight">
                        {product.title}
                      </h3>
                    </Link>
                    <span className="text-[9px] font-bold text-gray-300 uppercase tracking-widest mt-1">
                      {product.brand}
                    </span>
                  </div>
                  <p className="text-[12px] text-gray-400 line-clamp-2 mb-4 leading-relaxed flex-1">
                    {product.desc}
                  </p>
                  <div className="flex items-center justify-between gap-3 border-t border-[#ddd] pt-2">
                    <div className="flex items-center gap-0.5">
                      <span className="text-[10px] font-bold text-[#2A3182] opacity-50 uppercase tracking-tighter">Ksh.</span>
                      <span className="text-[18px] font-black text-[#2A3182] tracking-tight">{product.price}</span>
                    </div>
                    <button 
                      onClick={() => addToCart(product)}
                      className="bg-[#EF4444] text-white px-4 py-2 rounded-full text-[11px] font-bold hover:bg-red-600 transition-all shadow-md active:scale-95"
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
